import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../../services/i18nService';
import checkpointErrorDisplaySelector from '../../../selectors/idverification/CheckpointErrorDisplaySelector';

const CAPTION_PHOTO_APPROVED = 'idVerification.captureDevice.error.CAPTION_PHOTO_APPROVED';
const CAPTION_PHOTO_NOT_APPROVED = 'idVerification.captureDevice.error.CAPTION_PHOTO_NOT_APPROVED';

class PureCheckpointErrorDisplay extends React.PureComponent {
    static propTypes = {
        approved: PropTypes.bool.isRequired,
        message: PropTypes.string.isRequired,
        reason: PropTypes.string,
    };

    render() {
        const { approved, message, reason } = this.props;
        const mainLabel = approved
            ? CAPTION_PHOTO_APPROVED
            : CAPTION_PHOTO_NOT_APPROVED;

        return (
            <span>
                <strong>
                    {t(mainLabel)}
                </strong>
                <br />
                <strong>
                    {`${reason}`}
                </strong>
                {` ${message}`}
            </span>
        );
    }
}

function CheckpointErrorDisplay(props) {
    const newProps = checkpointErrorDisplaySelector.mapPropsToProps(props);

    return <PureCheckpointErrorDisplay {...props} {...newProps} />;
}

export default CheckpointErrorDisplay;
